module.exports = __webpack_public_path__ + "static/media/product_640-6.f9249755.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/product_640-6.jpg
// module id = 2389
// module chunks = 0